import { App } from '@openedx/frontend-base';
import { addScript, addSlot } from './utils';
import { Slot, WidgetOperationTypes } from '@openedx/frontend-base';

const customApp: App = {
  appId: 'custom',
};
const FOOTER_LEGAL_LINKS = [
  { label: 'Privacy Policy', href: 'https://openedx.org/privacy-policy/' },
  { label: 'Terms of Use', href: 'https://openedx.org/terms-of-use/' },
  { label: 'Cookies Policy', href: 'https://openedx.org/cookie-policy/' },
  { label: 'Code of Conduct', href: 'https://openedx.org/code-of-conduct/' },
];

const FOOTER_LANGUAGE_SLOT_ID = 'org.openedx.frontend.slot.footer.desktopRightLinks.v1';

function FooterLegalBar() {
  return (
    <footer role="contentinfo" className="footer-legal-bar">
      <style>{`
        /* No height fix needed here: the shell's DefaultLayout is already a
           min-vh-100 flex column with a flex-grow-1 main, so the footer sits at
           the bottom of short pages on its own. The legacy copy of this bar
           needs the #root repair; this one does not. */
        .footer-legal-bar {
          background-color: #07223c;
          padding: 1.25rem 1.5rem;
        }

        .footer-legal-bar__inner {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          gap: 1rem 1.5rem;
        }

        .footer-legal-bar__copyright {
          margin: 0;
          color: #fff;
          font-size: 0.875rem;
          line-height: 1.5;
        }

        .footer-legal-bar__actions {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 0.75rem 1.5rem;
        }

        .footer-legal-bar__links {
          display: flex;
          flex-wrap: wrap;
          gap: 0.625rem;
          margin: 0;
          padding: 0;
          list-style: none;
        }

        .footer-legal-bar__links a {
          color: rgba(255, 255, 255, 0.9);
          font-size: 0.875rem;
          line-height: 1.5;
          text-decoration: none;
        }

        .footer-legal-bar__links a:hover,
        .footer-legal-bar__links a:focus {
          color: #fff;
          text-decoration: underline;
        }

        /* Divider between the links and the dropdown, so the right-hand group
           reads as two things rather than one run-on row. Dropped once the bar
           wraps, where it would point at nothing. */
        .footer-legal-bar__language {
          display: flex;
          align-items: center;
          border-left: 1px solid rgba(255, 255, 255, 0.25);
          padding-left: 1.5rem;
        }

        @media (max-width: 62rem) {
          .footer-legal-bar__language {
            border-left: 0;
            padding-left: 0;
          }
        }

        /* The stock dropdown is btn-outline-primary: navy on navy, i.e.
           invisible here. These rules are unlayered and Paragon's are in a
           cascade layer, so they win without !important. */
        .footer-legal-bar__language .btn {
          color: #fff;
          background-color: transparent;
          border-color: rgba(255, 255, 255, 0.45);
        }

        .footer-legal-bar__language .btn:hover,
        .footer-legal-bar__language .btn:focus,
        .footer-legal-bar__language .btn:active,
        .footer-legal-bar__language .show > .btn {
          color: #07223c;
          background-color: #fff;
          border-color: #fff;
        }

        .footer-legal-bar__language .btn:focus {
          box-shadow: 0 0 0 0.1875rem rgba(255, 255, 255, 0.35);
        }
      `}</style>

      <div className="footer-legal-bar__inner">
        <p className="footer-legal-bar__copyright">
          &copy; {new Date().getFullYear()} Axim Collaborative, Inc. All Rights
          Reserved. edX and Open edX are registered trademarks of edX LLC.
        </p>

        <div className="footer-legal-bar__actions">
          <ul className="footer-legal-bar__links">
            {FOOTER_LEGAL_LINKS.map(({ label, href }) => (
              <li key={href}>
                <a href={href}>{label}</a>
              </li>
            ))}
          </ul>

          <div className="footer-legal-bar__language">
            <Slot id={FOOTER_LANGUAGE_SLOT_ID} />
          </div>
        </div>
      </div>
    </footer>
  );
}
addSlot(customApp, 
    {
      slotId: 'org.openedx.frontend.slot.footer.desktop.v1',
      op: WidgetOperationTypes.REPLACE,
      id: 'org.openedx.frontend.widget.footer.customLegalBar.v1',
      relatedId: 'org.openedx.frontend.widget.footer.desktopLayout.v1',
      component: FooterLegalBar,
    });

export default customApp;